import React from 'react'

import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function MissionThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={50} y={20} width={50} height={20} className={classes.fill} />
      <rect x={37.5} y={50} width={75} height={20} className={classes.fill} />
      <rect x={37.5} y={80} width={75} height={20} className={classes.fill} />

      <rect x={37.5} y={110} width={75} height={60} className={classes.fill} />
    </svg>
  )
}
